import React from "react";
import { DialogTitle } from "~/components/dialog";
import TextFormField from "~/components/text-form-field";
import FormBottomRow from "~/components/form-bottom-row";
import { ErrorRenderer, MutationForm } from "~/components/forms/MutationForm";
import { ValidationResponse } from "~/gql/types";
import { ProductDialog, FieldNote } from "./dialogChrome";
import { Product, unitNoun } from "./shared";

type RenameState = {
  name: string;
};

export type RenameProductDialogProps = {
  product: Product;
  open: boolean;
  loading: boolean;
  onCancel: () => void;
  onRename: (name: string) => Promise<ValidationResponse>;
  onSuccess: () => void;
};

export const RenameProductDialog: React.FC<RenameProductDialogProps> = ({
  product,
  open,
  loading,
  onCancel,
  onRename,
  onSuccess,
}) => {
  const unitLabel = unitNoun[product.unit];

  const initialValues: RenameState = {
    name: product.name,
  };

  return (
    <ProductDialog open={open} onClose={onCancel}>
      <DialogTitle>Rename Product</DialogTitle>
      <MutationForm
        initialValues={initialValues}
        runMutation={(values: RenameState) => onRename(values.name)}
        onSuccess={onSuccess}
      >
        <TextFormField
          formField="name"
          label="Name"
          helperText="The product name"
          required
        />
        <FieldNote>
          No other product billed by the {unitLabel} may share the new name. The
          same name is allowed on a product with a different unit.
        </FieldNote>
        <FieldNote>
          Renaming changes how this product is labelled wherever it appears,
          including on existing invoices. Amounts are unaffected — each rate
          keeps its own.
        </FieldNote>

        <ErrorRenderer
          render={(error) => (
            <FormBottomRow
              buttonText="Save"
              loading={loading}
              onCancel={onCancel}
              errorMessage={error}
            />
          )}
        />
      </MutationForm>
    </ProductDialog>
  );
};
